<template>
  <input-text
    v-model="value"
    :label="label"
    :name="name"
    v-bind="$attrs"
    :data-vv-as="label"
    v-validate="$attrs['v-validate'] || 'required|is_zip'"
    :error="currentError"
  />
</template>

<script>
import InputText from '@/components/InputText';
import { validatePostalCode } from '@/utils/postal-codes';
export default {
  name: 'input-zip',
  components: {
    'input-text': InputText
  },
  props: {
    name: {
      type: String,
      default: 'zip_code'
    },
    label: {
      type: String,
      default: 'Zip/Post code'
    },
    error: {
      type: String,
      default: ''
    },
    country: {
      type: Object,
      required: true
    }
  },
  prop: ['value'],
  data() {
    return {
      value: ''
    }
  },
  computed: {
    currentError() {
      return this.errors.first(this.name) || this.error;
    }
  },
  created() {
    this.value = this.$attrs.value;

    this.$validator.extend('is_zip', {
      getMessage: field =>  {
        return `${field} is not valid${this.country && this.country.name ? ' (' + this.country.name + ')' : ''}`;
      },
      validate: (value) => {
      return validatePostalCode(value, this.country.code);
      }
    });
  },
  watch: {
    value(val) {
      this.$emit('input', val.trim());
    },
    country: {
      deep: true,
      handler() {
        this.$validator.validate();
      }
    }
  }
}
</script>